import { render, staticRenderFns } from "./VersionInfo.vue?vue&type=template&id=0491c094"
import script from "./VersionInfo.vue?vue&type=script&lang=js"
export * from "./VersionInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports